exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-define-popup-container {\n    background-color: #F0F0F0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.css
// module id = ../../../../../src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.css
// module chunks = main